function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M438 104V147L170 414H165V104H438Z",
  className: "extra-color-2-lightened-1"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M438 140.88V414H165L438 140.88Z",
  className: "extra-color-2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M81.1001 189C69.5809 188.998 58.3198 192.412 48.741 198.81C39.1622 205.209 31.6958 214.304 27.2863 224.946C22.8767 235.587 21.7219 247.298 23.968 258.596C26.214 269.894 31.7601 280.272 39.9047 288.418C48.0493 296.564 58.4267 302.112 69.7244 304.36C81.0221 306.608 92.7327 305.455 103.375 301.048C114.018 296.64 123.114 289.175 129.514 279.597C135.914 270.02 139.33 258.759 139.33 247.24C139.362 239.584 137.877 231.997 134.962 224.917C132.048 217.838 127.76 211.405 122.346 205.991C116.933 200.577 110.501 196.288 103.422 193.371C96.3429 190.455 88.7564 188.97 81.1001 189V189Z",
  className: "primary-stroke",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.27 242L77.66 259.39L101.92 235.12",
  className: "primary-stroke",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M237 271.5H379",
  className: "extra-color-2-darkened-1-stroke",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M196 271.5H218",
  className: "extra-color-2-darkened-1-stroke",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M237 301.5H379",
  className: "extra-color-2-darkened-1-stroke",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M196 301.5H218",
  className: "extra-color-2-darkened-1-stroke",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M438 95.82V106H165V95.82C165 93.2156 166.035 90.7178 167.876 88.8762C169.718 87.0346 172.216 86 174.82 86H428.18C430.784 86 433.282 87.0346 435.124 88.8762C436.965 90.7178 438 93.2156 438 95.82V95.82Z",
  className: "extra-color-2-darkened-1"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M573.25 272.78C579.284 260.411 580.737 246.304 577.352 232.965C573.966 219.626 565.961 207.919 554.758 199.925C543.556 191.931 529.883 188.168 516.168 189.304C502.452 190.44 489.584 196.402 479.85 206.13",
  className: "primary-stroke",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M469 221.14C462.8 233.49 461.199 247.645 464.485 261.068C467.77 274.491 475.728 286.307 486.931 294.397C498.135 302.488 511.853 306.326 525.628 305.223C539.403 304.121 552.336 298.15 562.11 288.38",
  className: "primary-lightened-2-stroke",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M472.921 195.62L469.5 216.33L490.201 212.91L472.921 195.62Z",
  className: "primary"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M569.031 298.22L572.451 277.51L551.75 280.93L569.031 298.22Z",
  className: "primary-lightened-2"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M254.82 166.75C249.194 161.13 241.794 157.635 233.881 156.86C225.967 156.085 218.029 158.078 211.42 162.499C204.811 166.92 199.939 173.496 197.635 181.107C195.331 188.717 195.736 196.891 198.783 204.236C201.83 211.58 207.329 217.642 214.344 221.386C221.358 225.131 229.454 226.328 237.252 224.773C245.05 223.218 252.068 219.007 257.109 212.858C262.151 206.709 264.904 199.002 264.9 191.05C264.903 186.535 264.015 182.064 262.285 177.894C260.555 173.724 258.018 169.937 254.82 166.75V166.75Z",
  className: "extra-color-2-darkened-1"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M83 321V375H522V315",
  className: "primary-lightened-2-stroke",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeDasharray: "10.79 10.79"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M346.82 166.75C341.194 161.13 333.794 157.635 325.881 156.86C317.967 156.085 310.029 158.078 303.42 162.499C296.811 166.92 291.939 173.496 289.635 181.107C287.331 188.717 287.736 196.891 290.783 204.236C293.83 211.58 299.329 217.642 306.344 221.386C313.358 225.131 321.454 226.328 329.252 224.773C337.05 223.218 344.068 219.007 349.109 212.858C354.151 206.709 356.904 199.002 356.9 191.05C356.903 186.535 356.015 182.064 354.285 177.894C352.555 173.724 350.018 169.937 346.82 166.75Z",
  className: "extra-color-2-darkened-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 600,
    height: 500,
    viewBox: "0 0 600 500",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

export default __webpack_public_path__ + "static/media/objective_review_due.f02326d2.svg";
export { SvgComponent as ReactComponent };